import { render } from "./KajotPrimeGamesPage.vue?vue&type=template&id=dae2d61a&scoped=true"
import script from "./KajotPrimeGamesPage.vue?vue&type=script&lang=js"
export * from "./KajotPrimeGamesPage.vue?vue&type=script&lang=js"

import "./KajotPrimeGamesPage.vue?vue&type=style&index=0&id=dae2d61a&scoped=true&lang=css"

import exportComponent from "/Users/derem1991/workspace/newear/frontend/kajot/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dae2d61a"]])

export default __exports__